import { useEffect } from "react";
import "./App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import SpecialArrangements from "./pages/SpecialArrangements";
import AdminBookings from "./pages/AdminBookings";
import Account from "./pages/Account";
import { AuthProvider } from "./context/AuthContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/special-arrangements" element={<SpecialArrangements />} />
            <Route path="/admin" element={<AdminBookings />} />
            <Route path="/account" element={<Account />} />
          </Routes>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
      <WhatsAppButton />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
